module.exports = __webpack_public_path__ + "static/media/alien_pluck.0bdc07f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/alien_pluck.mp3
// module id = fkgu
// module chunks = 74